package com.wintermar.inspection.core.ui.theme.color.palette

import androidx.compose.ui.graphics.Color
import com.wintermar.inspection.core.ui.theme.color.model.ColorVariant

val WarningColorVariant = ColorVariant(
    n25 = Color(0xFFFFFCF5),
    n50 = Color(0xFFFFFAEB),
    n100 = Color(0xFFFEF0C7),
    n200 = Color(0xFFFEDF89),
    n300 = Color(0xFFFEC84B),
    n400 = Color(0xFFFDB022),
    n500 = Color(0xFFF79009),
    n600 = Color(0xFFDC6803),
    n700 = Color(0xFFB54708),
    n800 = Color(0xFF93370D),
    n900 = Color(0xFF7A2E0E)
)
